module.exports = __webpack_public_path__ + "img/train6.fba6f77a.jpeg";